import { processDemographicsTableData } from "../utils/dataProcessors";

import { useDemographicsData } from "./useDemographicsData";

export const useDemographicsTableData = () => {
    return useDemographicsData({
        select: (data) => processDemographicsTableData(data?.Table),
    });
};
